import React, {useEffect} from "react";
import Utilidade from '../context/Unidades'
import { useHistory, useParams } from "react-router";
import Unidades from "../context/Unidades";
import Home from "../pages/Home";
import Welcomepage from "../pages/Welcomepage";

const Home1 = () => {
  const {uf} = useParams()
  const history = useHistory();
  const [ipAddress, setIpAddress] = React.useState('');

  console.log(uf);
  if (uf === undefined) {
    history.push('/#ge')
    window.location.reload();
  }


  return (
    <div>
      {uf == "sp" || uf == "ge" ? <Welcomepage /> : <Home />}
    </div>    
  );


};

export default Home1;
